import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Monitor from '../views/Monitor.vue'
import HealthCheck from '../views/HealthCheck.vue'
import Choose from '../views/Choose.vue'
import Settings from '../views/Settings.vue'
import SingleStockHolder from '../views/SingleStockHolder.vue'
import MultipleStockScore from '../views/MultipleStockScore.vue'
import IndustryPlateHolders from '../views/IndustryPlateHolders.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/monitor' // 默认重定向到股票监控页面
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/monitor',
    name: 'Monitor',
    component: Monitor,
    meta: { requiresAuth: true }
  },
  {
    path: '/health-check/:stockCode?',
    name: 'HealthCheck',
    component: HealthCheck,
    meta: { requiresAuth: true },
    props: route => ({
      stockCode: route.params.stockCode || ''
    })
  },
  {
    path: '/choose',
    name: 'Choose',
    component: Choose,
    meta: { requiresAuth: true }
  },
  {
    path: '/single-stock-holder/:stockCode?/:yearLimit?',
    name: 'SingleStockHolder',
    component: SingleStockHolder,
    meta: { requiresAuth: true },
    props: route => ({
      stockCode: route.params.stockCode || '',
      yearLimit: route.params.yearLimit ? parseInt(route.params.yearLimit) : 5
    })
  },
  {
    path: '/multiple-stock-score/:stockCodes?',
    name: 'MultipleStockScore',
    component: MultipleStockScore,
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/industry-plate-holders/:plateId?/:yearLimit?',
    name: 'IndustryPlateHolders',
    component: IndustryPlateHolders,
    meta: { requiresAuth: true },
    props: route => ({
      plateId: route.params.plateId || null,
      yearLimit: route.params.yearLimit ? parseInt(route.params.yearLimit) : null
    })
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  let hasToken;
  try {
    hasToken = localStorage.getItem('authToken');
  } catch (error) {
    hasToken = false;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 如果目标路由需要认证
    if (!hasToken) {
      // 但用户没有 token
      next({ name: 'Login' }); // 重定向到登录页
    } else {
      // 用户有 token
      next(); // 继续访问
    }
  } else {
    // 如果目标路由不需要认证（例如登录页）
    if (hasToken && to.name === 'Login') {
      // 如果用户已经登录，但试图访问登录页，则直接跳转到监控页
      next({ name: 'Monitor' });
    } else {
      next(); // 否则正常访问
    }
  }
});


export default router